import { useAuthStore } from "~/store/auth";

export default defineNuxtRouteMiddleware((to, _from) => {
  const authStore = useAuthStore();
  const $toast = useNuxtApp().$toast;
  const $i18n = useNuxtApp().$i18n;

  if (to.path.startsWith("/transmission") && authStore.isSuperAdmin === false) {
    $toast.show({
      message: $i18n.t("llg.scms.validation.forbidden"),
      type: "danger",
    });
    return navigateTo({ path: "/campaign" }, { redirectCode: 403 });
  }
});
